import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "px-1" }
const _hoisted_2 = { class: "border-b border-t divide-y divide-ccc border-ccc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_filter_component = _resolveComponent("date-filter-component")!
  const _component_filter_kind_component = _resolveComponent("filter-kind-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createVNode(_component_date_filter_component),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kinds.slice(0, 6), (kind) => {
        return (_openBlock(), _createBlock(_component_filter_kind_component, {
          key: kind,
          kind: kind,
          filterVisible: _ctx.expandedFilters.includes(kind),
          "expanded-items": _ctx.expandedItems[kind],
          onToggleFilter: _ctx.toggleFilter,
          onToggleExpandedItem: _ctx.toggleExpandedItem
        }, null, 8, ["kind", "filterVisible", "expanded-items", "onToggleFilter", "onToggleExpandedItem"]))
      }), 128)),
      _createVNode(_component_filter_kind_component, {
        kind: "COLOR",
        filterVisible: _ctx.expandedFilters.includes('COLOR'),
        onToggleFilter: _ctx.toggleFilter
      }, null, 8, ["filterVisible", "onToggleFilter"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kinds.slice(6), (kind) => {
        return (_openBlock(), _createBlock(_component_filter_kind_component, {
          key: kind,
          kind: kind,
          filterVisible: _ctx.expandedFilters.includes(kind),
          "expanded-items": _ctx.expandedItems[kind],
          onToggleFilter: _ctx.toggleFilter,
          onToggleExpandedItem: _ctx.toggleExpandedItem
        }, null, 8, ["kind", "filterVisible", "expanded-items", "onToggleFilter", "onToggleExpandedItem"]))
      }), 128))
    ])
  ]))
}